import { render } from "./DetailsUser.vue?vue&type=template&id=714f85ce"
import script from "./DetailsUser.vue?vue&type=script&lang=js"
export * from "./DetailsUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__